<div class="settings-container" [class.settings-container--client]="!isAdmin">
	<div class="settings-layout">
		<div class="settings-sidebar">
			<div class="settings-sections">
				<div 
					*ngFor="let section of settingSections" 
					class="section-item"
					[class.active]="activeSection === section.id"
					(click)="selectSection(section.id)">
					<mat-icon>{{ section.icon }}</mat-icon>
					<span>{{ section.title | translate }}</span>
				</div>
			</div>
		</div>

		<div class="settings-content">
			<mat-card class="settings-card">
				<mat-card-header class="d-flex justify-content-between align-items-center w-100">
					<mat-card-title>{{ (getActiveSection()?.title) || '' | translate}}</mat-card-title>
						@if (activeSection === 'recordings') {
						<button mat-flat-button color="primary" (click)="openUploadRecordingDialog()">
							<mat-icon>upload</mat-icon>
							{{ 'RECORDINGS.UPLOAD.BUTTON' | translate }}
						</button>
						}
				</mat-card-header>
				<mat-card-content>
					<div [ngSwitch]="activeSection">
						<div *ngSwitchCase="'subscriptions'" class="section-content">
							<ng-container *ngIf="hasScope('client:subscriptions')">
								@if(isLoadingSubscriptions) {
								<div class="loading-container">
									<mat-spinner></mat-spinner>
								</div>
							} @else {
								<div class="subscriptions-table">
									<div class="mat-elevation-z2 px-0">
										<table mat-table [dataSource]="dataSourceSubscription">
										@for (column of displayedColumnsSubscription; track $index) {
										<ng-container [matColumnDef]="column">
											<th mat-header-cell *matHeaderCellDef>
												@switch (column) { @case ('ACTIONS') {} @default {
												{{ 'CLIENT.' + column | translate }}
												} }
											</th>
											<td mat-cell *matCellDef="let element" class="cursor-pointer" (click)="subscriptionAction('EDIT', element)">
												@switch (column) { @case ('TYPE') {
												{{ 'CLIENT.SUBSCRIPTION_TYPES.' + element['type'] | translate }}
												} @case ('EMAIL_TO') { @for(email of element['emailTo']; track $index) {
												{{ email }} <br />
												} } @case ('EMAIL_CC') { @for(email of element['emailCc']; track $index) {
												{{ email }} <br />
												} } @case ('VALID_FROM') {
												<!-- {{ element['validFrom'] | date:'shortDate' }} -->
												}@case ('VALID_TO') {
												<!-- <span [style.color]="getSubscriptionValidityStatus(element['validTo'])">
													{{ element['validTo'] | date:'shortDate' }}
												</span> -->
												}@case ('ACTIONS') {
												<button
													mat-icon-button
													color="primary"
													aria-label="Edit subscription"
													matTooltip="{{ 'BUTTON.EDIT' | translate }}"
													matTooltipPosition="below"
													(click)="subscriptionAction('EDIT', element); $event.stopPropagation()"
													[disabled]="isSubscriptionExpired(element.validTo)">
													<mat-icon>edit</mat-icon>
												</button>
												} }
											</td>
										</ng-container>
										}
										<tr mat-header-row *matHeaderRowDef="displayedColumnsSubscription; sticky: true"></tr>
										<tr
											mat-row
											*matRowDef="let row; columns: displayedColumnsSubscription"
											matTooltip="{{ !isSubscriptionExpired(row.validTo) ? ('ASSORTED.CLICK_TO_EDIT' | translate) : '' }}"
											matTooltipPosition="below"
											[class.expired-subscription]="isSubscriptionExpired(row.validTo)"
											(click)="!isSubscriptionExpired(row.validTo) && subscriptionAction('EDIT', row)">
										</tr>
									</table>
									</div>
								</div>
							}
							</ng-container>
						</div>
						
						<div *ngSwitchCase="'ai-presets'" class="section-content">
							<div class="ai-presets-header">
								<button mat-raised-button color="primary" type="button" (click)="openAiPresetDialog()" [disabled]="!canAddAiPreset()">
									<mat-icon>add</mat-icon>
									{{ 'SETTINGS.AI_PRESET.ADD' | translate }}
								</button>
							</div>

							@if (isLoadingAiPresets) {
							<div class="loading-container">
								<mat-spinner></mat-spinner>
							</div>
							} @else {
							@if (dataSourceAiPresets.data.length === 0) {
							<div class="ai-presets-empty">
								<mat-icon>smart_toy</mat-icon>
								<span>{{ 'SETTINGS.AI_PRESET.EMPTY' | translate }}</span>
							</div>
							} @else {
							<div class="mat-elevation-z2 px-0">
								<table mat-table [dataSource]="dataSourceAiPresets" class="ai-presets-table">
									@for (column of displayedColumnsAiPresets; track $index) {
									<ng-container [matColumnDef]="column">
										<th mat-header-cell *matHeaderCellDef>
											@switch (column) { @case ('ACTIONS') {} @default {
											{{ 'SETTINGS.AI_PRESET.' + column | translate }}
											} }
										</th>
										<td mat-cell *matCellDef="let element" class="cursor-pointer" (click)="openAiPresetDialog(element)">
											@switch (column) {
											@case ('TYPE') {
											{{ element.type }}
											}
											@case ('PROVIDER') {
											{{ 'SETTINGS.AI_PRESET.PROVIDERS.' + element.provider | translate }}
											}
											@case ('MODEL') {
											{{ element.model }}
											}
											@case ('ACTIONS') {
											<button mat-icon-button color="warn" type="button" (click)="deleteAiPreset(element, $event)" [matTooltip]="'BUTTON.DELETE' | translate">
												<mat-icon>delete</mat-icon>
											</button>
											}
											}
										</td>
									</ng-container>
									}
									<tr mat-header-row *matHeaderRowDef="displayedColumnsAiPresets"></tr>
									<tr mat-row *matRowDef="let row; columns: displayedColumnsAiPresets;"></tr>
								</table>
							</div>
							}
							}
						</div>

						<div *ngSwitchCase="'youtube-sources'" class="section-content">
							<div class="ai-presets-header">
								<button mat-raised-button color="primary" type="button" (click)="openYoutubeSourceDialog()">
									<mat-icon>add</mat-icon>
									{{ 'SETTINGS.YOUTUBE_SOURCE.ADD' | translate }}
								</button>
								<button
									mat-stroked-button
									color="primary"
									type="button"
									(click)="downloadSelectedYoutubeSourcesNow()"
									[disabled]="selectedYoutubeSourceIds.size === 0 || isBatchDownloadingYoutubeSources">
									<mat-icon>cloud_download</mat-icon>
									{{ 'SETTINGS.YOUTUBE_SOURCE.DOWNLOAD.BATCH_BUTTON' | translate: { count: selectedYoutubeSourceIds.size } }}
								</button>
							</div>

							@if (pendingYoutubeEnabled.size > 0) {
							<div class="youtube-pending-bar d-flex align-items-center gap-2">
								<span>{{ 'SETTINGS.YOUTUBE_SOURCE.UNSAVED_CHANGES' | translate: { count: pendingYoutubeEnabled.size } }}</span>
								<button mat-flat-button color="primary" type="button" (click)="confirmYoutubeEnabledChanges()" [disabled]="isSavingYoutubeEnabledChanges">
									{{ 'BUTTON.CONFIRM' | translate }}
								</button>
								<button mat-stroked-button color="primary" type="button" (click)="cancelYoutubeEnabledChanges()" [disabled]="isSavingYoutubeEnabledChanges">
									{{ 'BUTTON.CANCEL' | translate }}
								</button>
							</div>
							}

							<div class="youtube-schedule-panel">
								<mat-slide-toggle class="youtube-toggle" [(ngModel)]="youtubeAutoDownloadEnabled">
									{{ (youtubeAutoDownloadEnabled ? 'SETTINGS.YOUTUBE_SOURCE.SCHEDULE_SETTINGS.ENABLED_ON' : 'SETTINGS.YOUTUBE_SOURCE.SCHEDULE_SETTINGS.ENABLED_OFF') | translate }}
								</mat-slide-toggle>

								<mat-form-field appearance="outline" class="general-times-field">
									<mat-label>{{ 'SETTINGS.YOUTUBE_SOURCE.SCHEDULE_SETTINGS.GENERAL_TIMES' | translate }}</mat-label>
									<mat-chip-grid #generalTimesChipGrid>
										@for (time of youtubeGeneralScheduleTimes; track time) {
										<mat-chip-row (removed)="removeGeneralScheduleTime(time)">
											{{ time }}
											<button matChipRemove>
												<mat-icon>cancel</mat-icon>
											</button>
										</mat-chip-row>
										}
									</mat-chip-grid>
									<input
										matInput
										placeholder="08:00"
										[matChipInputFor]="generalTimesChipGrid"
										[matChipInputSeparatorKeyCodes]="scheduleTimeSeparatorKeyCodes"
										(matChipInputTokenEnd)="addGeneralScheduleTime($event)" />
								</mat-form-field>

								<button
									mat-flat-button
									color="primary"
									type="button"
									(click)="saveYoutubeAutoDownloadSettings()"
									[disabled]="isSavingYoutubeAutoDownloadSettings">
									{{ 'BUTTON.SAVE' | translate }}
								</button>
							</div>

							@if (isLoadingYoutubeSources) {
							<div class="loading-container">
								<mat-spinner></mat-spinner>
							</div>
							} @else {
							@if (dataSourceYoutubeSources.data.length === 0) {
							<div class="ai-presets-empty">
								<mat-icon>smart_display</mat-icon>
								<span>{{ 'SETTINGS.YOUTUBE_SOURCE.EMPTY' | translate }}</span>
							</div>
							} @else {
							<div class="mat-elevation-z2 px-0">
								<table mat-table [dataSource]="dataSourceYoutubeSources" class="ai-presets-table">
									@for (column of displayedColumnsYoutubeSources; track $index) {
									<ng-container [matColumnDef]="column">
										<th mat-header-cell *matHeaderCellDef>
											@switch (column) { @case ('ACTIONS') {} @case ('SELECT') {} @default {
											{{ 'SETTINGS.YOUTUBE_SOURCE.' + column | translate }}
											} }
										</th>
										<td mat-cell *matCellDef="let element" class="cursor-pointer" (click)="openYoutubeSourceDialog(element)">
											@switch (column) {
											@case ('SELECT') {
											<mat-checkbox [checked]="selectedYoutubeSourceIds.has(element.id)" (click)="$event.stopPropagation()" (change)="toggleYoutubeSourceSelected(element)"></mat-checkbox>
											}
											@case ('NAME') {
											{{ element.name }}
											}
											@case ('TYPE') {
											{{ 'SETTINGS.YOUTUBE_SOURCE.TYPES.' + element.type | translate }}
											}
											@case ('KEYWORDS') {
											{{ element.keywords || '—' }}
											}
											@case ('LAST_CHECKED_AT') {
											{{ element.lastCheckedAt ? (element.lastCheckedAt | date: 'dd.MM.yyyy HH:mm') : '—' }}
											}
											@case ('SCHEDULE') {
											{{ element.customScheduleTimes || (youtubeGeneralScheduleTimes.length ? youtubeGeneralScheduleTimes.join(', ') : ('SETTINGS.YOUTUBE_SOURCE.SCHEDULE_GENERAL' | translate)) }}
											}
											@case ('ENABLED') {
											<mat-slide-toggle class="youtube-toggle" [checked]="isYoutubeSourceEnabledChecked(element)" (click)="$event.stopPropagation()" (change)="stageYoutubeSourceEnabledChange(element)"></mat-slide-toggle>
											}
											@case ('ACTIONS') {
											<button mat-icon-button color="primary" type="button" (click)="openYoutubeSourceDialog(element); $event.stopPropagation()" [matTooltip]="'BUTTON.EDIT' | translate">
												<mat-icon>edit</mat-icon>
											</button>
											<button mat-icon-button color="primary" type="button" (click)="openYoutubeSourcePreviewDialog(element, $event)" [matTooltip]="'SETTINGS.YOUTUBE_SOURCE.PREVIEW.BUTTON' | translate">
												<mat-icon>visibility</mat-icon>
											</button>
											<button
												mat-icon-button
												color="primary"
												type="button"
												(click)="downloadYoutubeSourceNow(element, $event)"
												[disabled]="downloadingYoutubeSourceIds.has(element.id)"
												[matTooltip]="(downloadingYoutubeSourceIds.has(element.id) ? 'SETTINGS.YOUTUBE_SOURCE.DOWNLOAD.IN_PROGRESS' : 'SETTINGS.YOUTUBE_SOURCE.DOWNLOAD.BUTTON') | translate">
												@if (downloadingYoutubeSourceIds.has(element.id)) {
												<mat-spinner diameter="20"></mat-spinner>
												} @else {
												<mat-icon>cloud_download</mat-icon>
												}
											</button>
											<button mat-icon-button color="warn" type="button" (click)="deleteYoutubeSource(element, $event)" [matTooltip]="'BUTTON.DELETE' | translate">
												<mat-icon>delete</mat-icon>
											</button>
											}
											}
										</td>
									</ng-container>
									}
									<tr mat-header-row *matHeaderRowDef="displayedColumnsYoutubeSources"></tr>
									<tr mat-row *matRowDef="let row; columns: displayedColumnsYoutubeSources;"></tr>
								</table>
							</div>
							}
							}
						</div>

						<div *ngSwitchCase="'recording-schedules'" class="section-content">
							<app-recording-schedule-gantt [embedded]="true"></app-recording-schedule-gantt>
						</div>

						<div *ngSwitchCase="'recordings'" class="section-content">
							<app-recordings [embedded]="true"></app-recordings>
						</div>

						<div *ngSwitchCase="'youtube-download-log'" class="section-content">
							<app-youtube-download-log></app-youtube-download-log>
						</div>

						<div *ngSwitchCase="'ai-prices'" class="section-content">
							<div class="ai-presets-header">
								<button mat-raised-button color="primary" type="button" (click)="openAiPriceDialog()">
									<mat-icon>add</mat-icon>
									{{ 'SETTINGS.AI_PRICE.ADD' | translate }}
								</button>
							</div>

							@if (isLoadingAiPrices) {
							<div class="loading-container">
								<mat-spinner></mat-spinner>
							</div>
							} @else {
							@if (dataSourceAiPrices.data.length === 0) {
							<div class="ai-presets-empty">
								<mat-icon>payments</mat-icon>
								<span>{{ 'SETTINGS.AI_PRICE.EMPTY' | translate }}</span>
							</div>
							} @else {
							<div class="mat-elevation-z2 px-0">
								<table mat-table [dataSource]="dataSourceAiPrices" class="ai-presets-table">
									@for (column of displayedColumnsAiPrices; track $index) {
									<ng-container [matColumnDef]="column">
										<th mat-header-cell *matHeaderCellDef>
											@switch (column) { @case ('ACTIONS') {} @default {
											{{ 'SETTINGS.AI_PRICE.' + column | translate }}
											} }
										</th>
										<td mat-cell *matCellDef="let element" class="cursor-pointer" (click)="openAiPriceDialog(element)">
											@switch (column) {
											@case ('PROVIDER') {
											{{ 'SETTINGS.AI_PRESET.PROVIDERS.' + element.provider | translate }}
											}
											@case ('MODEL') {
											{{ element.model }}
											}
											@case ('PRICE_PER_MILLION_INPUT_TOKENS') {
											{{ element.pricePerMillionInputTokens }}
											}
											@case ('PRICE_PER_MILLION_OUTPUT_TOKENS') {
											{{ element.pricePerMillionOutputTokens }}
											}
											@case ('PRICE_PER_MILLION_CACHED_INPUT_TOKENS') {
											{{ element.pricePerMillionCachedInputTokens ?? '—' }}
											}
											@case ('EFFECTIVE_FROM') {
											{{ element.effectiveFrom | date:'shortDate' }}
											}
											@case ('ACTIONS') {
											<button mat-icon-button color="warn" type="button" (click)="deleteAiPrice(element, $event)" [matTooltip]="'BUTTON.DELETE' | translate">
												<mat-icon>delete</mat-icon>
											</button>
											}
											}
										</td>
									</ng-container>
									}
									<tr mat-header-row *matHeaderRowDef="displayedColumnsAiPrices"></tr>
									<tr mat-row *matRowDef="let row; columns: displayedColumnsAiPrices;"></tr>
								</table>
							</div>
							}
							}
						</div>

						<div *ngSwitchCase="'social-dossiers'" class="section-content">
							<app-social-dossiers></app-social-dossiers>
						</div>

						<div *ngSwitchCase="'social-settings'" class="section-content">
							<app-social-settings></app-social-settings>
						</div>

						<div *ngSwitchCase="'clip-auto-grouping'" class="section-content">
							<app-clip-auto-grouping-settings></app-clip-auto-grouping-settings>
						</div>

						<div *ngSwitchCase="'ai-usage-export'" class="section-content">
							<form [formGroup]="usageExportForm" (ngSubmit)="exportUsage()" class="usage-export-fields">
								<mat-form-field appearance="outline" class="full-width">
									<mat-date-range-input [rangePicker]="usageExportPicker">
										<input matStartDate formControlName="dateFrom" placeholder="{{ 'SETTINGS.AI_USAGE_EXPORT.DATE_FROM' | translate }}">
										<input matEndDate formControlName="dateTo" [max]="getUsageExportMaxDateTo()" placeholder="{{ 'SETTINGS.AI_USAGE_EXPORT.DATE_TO' | translate }}">
									</mat-date-range-input>
									<mat-datepicker-toggle matIconSuffix [for]="usageExportPicker"></mat-datepicker-toggle>
									<mat-date-range-picker #usageExportPicker></mat-date-range-picker>
									<mat-hint *ngIf="!usageExportForm.errors && !usageExportForm.get('dateTo')?.hasError('matDatepickerMax')">{{ 'SETTINGS.AI_USAGE_EXPORT.MAX_RANGE_HINT' | translate }}</mat-hint>
									<mat-error *ngIf="usageExportForm.hasError('rangeInvalid') || usageExportForm.hasError('rangeTooLong') || usageExportForm.get('dateTo')?.hasError('matDatepickerMax')">
										{{ 'SETTINGS.AI_USAGE_EXPORT.INVALID_RANGE' | translate }}
									</mat-error>
								</mat-form-field>

								<div class="form-actions">
									<button
										mat-raised-button
										color="primary"
										type="submit"
										[disabled]="usageExportForm.invalid || isExportingUsage">
										<div class="d-flex align-items-center">
											@if(isExportingUsage) {
											<mat-spinner diameter="15" class="me-2"></mat-spinner>
											}
											<mat-icon>download</mat-icon>
											<span>{{ 'SETTINGS.AI_USAGE_EXPORT.DOWNLOAD' | translate }}</span>
										</div>
									</button>
								</div>
							</form>
						</div>

						<div *ngSwitchCase="'password'" class="section-content">
							<form [formGroup]="changePasswordForm" (ngSubmit)="onChangePassword()">
								<div class="password-fields">
									<mat-form-field appearance="outline" class="full-width">
										<mat-label>{{ 'CLIENT_SETTINGS.OLD_PASSWORD' | translate }}</mat-label>
										<input matInput [type]="oldPasswordVisible ? 'text' : 'password'" formControlName="oldPassword" autocomplete="current-password">
										<button mat-icon-button matSuffix type="button" (click)="oldPasswordVisible = !oldPasswordVisible" [attr.aria-label]="'Toggle password visibility'">
											<mat-icon color="primary">{{ oldPasswordVisible ? 'visibility' : 'visibility_off' }}</mat-icon>
										</button>
										<mat-error *ngIf="changePasswordForm.get('oldPassword')?.hasError('required')">
											{{ 'NOTIFICATIONS.REQUIRED_VALUE' | translate }}
										</mat-error>
									</mat-form-field>

									<mat-form-field appearance="outline" class="full-width">
										<mat-label>{{ 'CLIENT_SETTINGS.NEW_PASSWORD' | translate }}</mat-label>
										<input matInput [type]="newPasswordVisible ? 'text' : 'password'" formControlName="newPassword" autocomplete="new-password">
										<button mat-icon-button matSuffix type="button" (click)="newPasswordVisible = !newPasswordVisible" [attr.aria-label]="'Toggle password visibility'">
											<mat-icon color="primary">{{ newPasswordVisible ? 'visibility' : 'visibility_off' }}</mat-icon>
										</button>
										<mat-error *ngIf="changePasswordForm.get('newPassword')?.hasError('required')">
											{{ 'NOTIFICATIONS.REQUIRED_VALUE' | translate }}
										</mat-error>
									</mat-form-field>

									<mat-form-field appearance="outline" class="full-width">
										<mat-label>{{ 'CLIENT_SETTINGS.CONFIRM_PASSWORD' | translate }}</mat-label>
										<input matInput [type]="confirmPasswordVisible ? 'text' : 'password'" formControlName="confirmPassword" autocomplete="new-password">
										<button mat-icon-button matSuffix type="button" (click)="confirmPasswordVisible = !confirmPasswordVisible" [attr.aria-label]="'Toggle password visibility'">
											<mat-icon color="primary">{{ confirmPasswordVisible ? 'visibility' : 'visibility_off' }}</mat-icon>
										</button>
										<mat-error *ngIf="changePasswordForm.get('confirmPassword')?.hasError('required')">
											{{ 'NOTIFICATIONS.REQUIRED_VALUE' | translate }}
										</mat-error>
										<mat-error *ngIf="changePasswordForm.get('confirmPassword')?.hasError('passwordMismatch')">
											{{ 'NOTIFICATIONS.PASSWORD_MISMATCH' | translate }}
										</mat-error>
									</mat-form-field>
								</div>

								<div class="form-actions">
									<button 
										mat-raised-button 
										color="primary" 
										type="submit" 
										[disabled]="changePasswordForm.invalid || isChangingPassword"
										[matTooltip]="'CLIENT_SETTINGS.CHANGE_PASSWORD_LOGOUT' | translate"
										matTooltipPosition="below">
										<div class="d-flex align-items-center">
											@if(isChangingPassword) {
											<mat-spinner diameter="15" class="me-2"></mat-spinner>
											}
											<span>{{ 'CLIENT_SETTINGS.CHANGE_PASSWORD' | translate }}</span>
										</div>
									</button>
								</div>
							</form>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
		</div>
	</div>
</div>